<template>
  <div class="about">
    <h1>This is an about page</h1>
    <input type="text" v-model="msg">
    <div @click="sendMsg">fasong</div>
    <div @click="getdMsg">获取</div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        nim:null,
        initFinish:false,
        msg:''
      }
    },
    mounted() {
      this.initIM()
    },
    methods:{
      initIM(){
        let _that = this
        this.$nextTick(()=>{
          this.nim = this.NIM.getInstance({
            debug: true,   // 是否开启日志，将其打印到console。集成开发阶段建议打开。
            appKey: '7f04e1c69a70c76abe78563ce9831a39',
            account: 'test',//用于登录IM
            token: '123456',//用于登录IM
            db:false, //若不要开启数据库请设置false。SDK 默认为true。
            autoMarkRead: true, // 开启自动标记消息已读
            syncSessionUnread: true, // 同步会话的未读数,
            onwillreconnect: _that.onWillReconnect, // NIM SDK 与云信服务端的长连接已断开，而且正在重连时触发的回调函数
            ondisconnect: _that.onDisconnect, // NIM SDK 与云信服务端的长连接断开后的回调函数
            onconnect: _that.onConnect,
            onofflinemsgs: _that.onOfflineMsgs,// 初始化同步时，用于接收离线消息的回调函数
            onmsg: _that.onMsg, // 用户在线或多端同步时，用于接收消息的回调函数（实时消息）
            onsessions: _that.onSessions, // 初始化同步时，用于获取会话列表的回调函数
            onsyncdone: function () {
              _that.initFinish = true
            } // 同步完成
          });
        })

      },
      onOfflineMsgs(msg){
        console.log('--------------------msg')
        console.log(msg)
      },
      onConnect(msg){
        console.log('收到消息onConnect', msg);
      },
      onMsg(msg) {
        console.log('收到消息', msg.scene, msg.type, msg);
      },
      onDisconnect(msg){
        console.log('收到消息onDisconnect', msg);
      },
      onWillReconnect(msg){
        console.log('收到消息onWillReconnect', msg);
      },
      onSessions(msg){
        console.log('收到消息onSessions', msg);
      },
      sendMsg(){
        this.nim.sendText({
          scene: 'p2p',
          to: 'test',
          text: this.msg,
          done: this.sendMsgDone
        });
      },
      sendMsgDone(error, msg){
        console.log(error);
        // console.log(msg);
        console.log('发送' + msg.scene + ' ' + msg.type + '消息' + (!error?'成功':'失败') + ', id=' + msg.idClient);
      },
      getdMsg(){
        this.nim.getHistoryMsgs({
          scene: 'p2p',
          to: 'test',
          done:(error, msg)=>{
            console.log(error)
            console.log(msg)
          }
        })
      }
    }
  }
</script>
